import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Link,
    Stack,
    Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { MainLayout } from "../components/Layouts/MainLayout";
import { theme } from "../theme/theme";
import styles from "./AboutUsPage.module.scss";
import { Helmet } from "react-helmet";

const ContactUsPage = () => {
    return (
        <MainLayout>
            <Helmet>
                <title>Contact Us - Nrby Events</title>
            </Helmet>
            <Card sx={{ padding: { xs: 0 }, marginTop: { xs: "30px" } }}>
                <Box style={{ position: "relative" }}>
                    <Box
                        component="div"
                        style={{
                            height: "100%",
                            position: "absolute",
                            backgroundImage: `url('/images/about-us/about-us-bg.png')`,
                            backgroundSize: "cover",
                            opacity: "0.25",
                            width: "100%",
                            zIndex: 0,
                            overflow: "hidden",
                        }}
                    >
                        &nbsp;
                    </Box>
                    <CardContent
                        className={styles.mainContent}
                        sx={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: { xl: "1250px", xs: "100%" },
                            maxWidth: { lg: "1250px" },
                            padding: { xs: "20px", lg: "20px" },
                        }}
                    >
                        <Grid
                            container
                            spacing={3}
                            sx={{
                                paddingTop: { xs: "0", md: "120px" },
                                paddingBottom: { xs: "0", md: "100px" },
                            }}
                        >
                            <Grid item xs={12} >
                                <Stack direction="column" spacing={4}>
                                    <Typography
                                        variant="header01"
                                        textAlign="left"
                                    >
                                        Contact us
                                    </Typography>
                                    <Grid container xs={12} alignItems="center">
                                        <Grid xs={12} item >
                                            <Typography
                                                 variant="subheader01"
                                                    textAlign="left"
                                                >
                                                Have a question?
                                            </Typography>
                                        </Grid>
                                        <Grid xs={12} item >
                                            <Typography
                                                    variant="subheader01"
                                                    textAlign="left"
                                                    style={{paddingTop: "20px"}}    
                                                >
                                                Already have tickets and need some help?
                                            </Typography>
                                        </Grid>
                                        <Grid xs={12} item >
                                            <Typography
                                                     variant="subheader01"
                                                    textAlign="left"
                                                    style={{paddingTop: "20px"}}  
                                                >
                                                Don't have tickets or have a problem?
                                            </Typography>
                                        </Grid>
                                        <Grid xs={12} item >
                                            <Typography
                                                 variant="subheader01"
                                                    textAlign="left"
                                                    style={{paddingTop: "20px"}}  
                                                >
                                                Email us, we're here to help! <br />
                                                <Link href="mailto:support@nrby.io" underline="hover" style={{ color: theme.palette.nrbyColors.tangerine }}>
                                                    support@nrby.io
                                                </Link>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Stack>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Box>
            </Card>
        </MainLayout>
    );
};

export default ContactUsPage;
